<template>
  <div class="card-header">
    <div class="row">
      <div>
        <div class="col-sm-2" :style="'text-align: center; line-height: 34px'">
          <div>{{ clock }}</div>
        </div>
        <div class="col-sm-3">
          <date-picker :lang="lang" v-model="$parent.startDate" valueType="format" format="YYYY-MM-DD" :placeholder="t.start_date"></date-picker>
        </div>
        <div class="col-sm-3">
          <date-picker :lang="lang" v-model="$parent.endDate" valueType="format" format="YYYY-MM-DD" :placeholder="t.end_date"></date-picker>
        </div>
        <div class="col-sm-2">
          <input type="button" class="btn btn-success btn-block" :value="t.query_now" style="margin-top:2px"
                 @click="dateFilter($parent.startDate, $parent.endDate)">
        </div>
      </div>
      <div class="col-sm-4">
        <a class="btn btn-link text-info" style="margin-top:2px"
           @click="thisWeek()">{{ t.filter.accounting.this_week }}</a>
        <a class="btn btn-link text-info"
           @click="dateFilter($root.moment(new Date()).startOf('month'), $root.moment(new Date()))"
           style="margin-top:2px">{{ t.filter.accounting.this_month }}</a>
        <a class="btn btn-link text-info"
           @click="previousWeek()"
           style="margin-top:2px">{{ t.filter.accounting.yesterweek }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';
import 'moment/locale/de';
moment.locale('de');


export default {
  name: "DateFilter",
  props: ['startDate', 'endDate', 'type'],
  components: {DatePicker},
  data() {return {t: this.$root.t, notAfter: new Date(), clock: '', lockInt: '',
  lang: {
  // the locale of formatting and parsing function
  formatLocale: {
    // MMMM
    months: ['Jan', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    // MMM
    monthsShort: this.$root.t.times.months,
    // dddd
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    // ddd
    weekdaysShort: this.$root.t.times.days,
    // dd
    weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    // first day of week
    firstDayOfWeek: 0,
    // first week contains January 1st.
    firstWeekContainsDate: 1,
    // format 'a', 'A'
  },
  // the calendar header, default formatLocale.weekdaysMin
  days: [],
  // the calendar months, default formatLocale.monthsShort
  months: [],
  // the calendar title of year

  // the calendar title of month before year
  monthBeforeYear: false,
}
}},
  mounted () {
    
    setTimeout (() => {
      this.thisWeek ()
    }, 1000)
    this.lockInt = setInterval(this.clockT, 1000)
  },
  beforeDestroy() {
    clearInterval(this.lockInt)
  },
  methods: {
    clockT () {
      this.$set( this, 'clock', this.moment().utc().format('MM/DD/YYYY HH:mm:ss') )
    },
    thisWeek () {
      var d = new Date();
      var day = d.getDay();

      if(day >= 2 || day == 0 || day == 1){
        if(day == 1){
          this.dateFilter(this.$root.moment(new Date()).startOf('week').add(-6, 'd'), this.$root.moment(new Date()).startOf('week').add(0, 'd'))
        }else {
          this.dateFilter(this.$root.moment(new Date()).startOf('week').add(1, 'd'), this.$root.moment(new Date()).startOf('week').add(7, 'd'))
        }
      }else {
        if(day == 1){
          this.dateFilter(this.$root.moment(new Date()).startOf('week').add(1, 'd').subtract(-14, 'd'), this.$root.moment(new Date()).startOf('week').subtract(1, 'd'))
        }else {
          this.dateFilter(this.$root.moment(new Date()).startOf('week').add(1, 'd').subtract(7, 'd'), this.$root.moment(new Date()).startOf('week').subtract(1, 'd'))
        }
      }
    },
    previousWeek () {
      var d = new Date();
      var day = d.getDay();

      if(day >= 2 || day == 0 || day == 1){

        if(day == 1){
          this.dateFilter(this.$root.moment(new Date()).startOf('week').add(-13, 'd'), this.$root.moment(new Date()).startOf('week').add(-7, 'd'))
        }else {
          this.dateFilter(this.$root.moment(new Date()).startOf('week').add(1, 'd').subtract(7, 'days'), this.$root.moment(new Date()).startOf('week').add(1, 'd').subtract(7, 'days').add(6, 'days'))
        }

      }else {
        this.dateFilter(this.$root.moment(new Date()).startOf('week').add(1, 'd').subtract(7, 'days'), this.$root.moment(new Date()).startOf('week').subtract(1, 'd'))
      }
    },
    dateFilter(start, end) {   

      if(typeof start === 'string'){
        
      }else {
        start = (start) ? start.format("YYYY-MM-DD") : this.$parent.startDate;
        end = (end) ? end.format("YYYY-MM-DD") : this.$parent.endDate;
      }


      this.$parent.startDate = start;
      this.$parent.endDate = end;

      if(typeof this.$parent.fetchTransactions !== "undefined"){
        if(start && end) {
          this.$parent.fetchTransactions(start, end, false);
        }else {
          this.$parent.fetchTransactions(this.startDate, this.endDate, false)
        }
      }else {

      }

      this.$emit('data-change', {start: start, end: end})

    },
    disabledAfter(date) {
      return date.setHours(0, 0, 0, 0) > new Date(moment(this.$parent.endDate, 'DD MMMM YYYY ddd').format('YYYY-MM-DD')).setHours(0, 0, 0, 0);
    },
    disabledAfterToday(date) {
      return date.setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DateFilter.vue